{
  "title": "Profile",
  "description": "Manage your profile information and settings",
  "tabs": {
    "personal": "Personal Information",
    "security": "Security",
    "devices": "Devices",
    "feedback": "Feedback"
  },
  "personal": {
    "title": "Personal Information",
    "description": "Update your personal data",
    "success": "Personal information updated successfully",
    "successDescription": "Your personal information has been updated successfully",
    "error": "Error updating personal information",
    "errorDescription": "An error occurred while updating your personal information.",
    "fields": {
      "avatar": "Profile Picture",
      "uploadAvatar": "Upload Photo",
      "avatarError": "Image Upload Error",
      "firstName": "First Name",
      "lastName": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "gender": "Gender",
      "genderOptions": {
        "man": "Man",
        "woman": "Woman",
        "other": "Other"
      },
      "language": "Language",
      "languageOptions": {
        "en": "English",
        "fr": "French"
      },
      "theme": "Theme",
      "themeOptions": {
        "light": "Light",
        "dark": "Dark",
        "system": "System"
      },
      "imageProcessError": "Failed to process image file"
    },
    "saveChanges": "Save Changes",
    "updating": "Updating...",
    "personalization": {
      "title": "Personalization",
      "description": "Customize your experience"
    }
  },
  "security": {
    "title": "Security Settings",
    "description": "Manage your account security",
    "changePassword": {
      "title": "Change Password",
      "description": "Update your account password for enhanced security.",
      "fields": {
        "currentPassword": "Current Password",
        "newPassword": "New Password",
        "confirmPassword": "Confirm New Password"
      },
      "button": "Update Password",
      "updating": "Updating...",
      "success": "Password updated successfully",
      "successDescription": "Your password has been updated successfully",
      "error": "Error updating password",
      "errorDescription": "An error occurred while updating your password.",
      "errors": {
        "currentRequired": "Current password is required",
        "newRequired": "New password is required",
        "confirmRequired": "Please confirm your new password",
        "minLength": "Password must be at least 6 characters",
        "noMatch": "Passwords do not match",
        "samePassword": "New password must be different from current password",
        "wrongCurrent": "Current password is incorrect"
      }
    }
  },
  "feedback": {
    "mainTitle": "Send Feedback",
    "description": "Help us improve by sharing your thoughts and suggestions",
    "title": {
      "label": "Title",
      "placeholder": "Brief summary of your feedback"
    },
    "type": {
      "label": "Feedback Type",
      "placeholder": "Select feedback type",
      "options": {
        "bug": "Bug Report",
        "feature": "Feature Request",
        "contact": "Contact",
        "other": "Other"
      }
    },
    "message": {
      "label": "Message",
      "placeholder": "Describe your feedback in detail..."
    },
    "anonymous": {
      "label": "Send anonymously",
      "description": "Your feedback will be sent without your user information"
    },
    "send": "Send Feedback",
    "sending": "Sending...",
    "success": "Feedback sent successfully !"
  },
  "errors": {
    "createProfileFailed": "Failed to create profile",
    "loadProfileFailed": "Failed to load profile",
    "updateProfileFailed": "Failed to update profile"
  },
  "success": {
    "profileCreated": "Profile created successfully",
    "profileUpdated": "Profile updated successfully"
  }
}
